const API_BASE_URL = '';

export const API_ENDPOINTS = {
    LOGIN: `${API_BASE_URL}/api/auth/login`,
    FORGOT_PASSWORD: `${API_BASE_URL}/api/auth/forgot-password`,
    REGISTER: `${API_BASE_URL}/api/auth/register`,
    VERIFY: `${API_BASE_URL}/api/auth/verify`,
    RESENDVERIFICATION: `${API_BASE_URL}/api/auth/resend-verification`,
    VALIDATE_TOKEN: `${API_BASE_URL}/api/auth/validate-reset-token`,
    RESET_PASSWORD: `${API_BASE_URL}/api/auth/reset-password`,

    DASHPROFILE: `${API_BASE_URL}/api/dashboard/profile`,
    MYLISTINGS: `${API_BASE_URL}/api/job/my-listings`,
    UPDATESTATUS: `${API_BASE_URL}/api/job/update-status`,
    POSTJOB: `${API_BASE_URL}/api/job/post-job`,
    LISTINGS: `${API_BASE_URL}/api/job/listings`,
    APPLICATIONS: `${API_BASE_URL}/api/job/applications`,
    //Employer Specific
    EMPDASHBOARD: `${API_BASE_URL}/api/dashboard/employerdashboard`,
    EMPSHORTLIST: `${API_BASE_URL}/api/job/shortlist`,
    EMPJOBDETAILS: `${API_BASE_URL}/api/employer/job-details`,
    EMPUPDATELISTING: `${API_BASE_URL}/api/employer/update-listing`,
    EMPLOYERCANDIDATES: `${API_BASE_URL}/api/employer/candidates`,
    EMPLOYERSEARCHTALENT: `${API_BASE_URL}/api/employer/search-candidates`,
    EMPLOYERPROFILE: `${API_BASE_URL}/api/employer/company-profile`,
    EMPLOYERPROFILELOGO: `${API_BASE_URL}/api/employer/company-logo`,

    //JOB SEEKER Specific
    SEEKERDASHBOARD: `${API_BASE_URL}/api/jobseeker/dashboard`,
    EMPJOBS: `${API_BASE_URL}/api/jobseeker/jobs`,
    EMPBROWSEJOBS: `${API_BASE_URL}/api/jobseeker/browsejobs`,
    EMPPROFILE: `${API_BASE_URL}/api/jobseeker/my-profile`,
    DIMENSIONS: `${API_BASE_URL}/api/dimensions`,
    UPDATEPROFILE: `${API_BASE_URL}/api/jobseeker/update-profile`,
    UPLOADCERTIFICATE: `${API_BASE_URL}/api/jobseeker/upload-certificate`,
    UPLOADCV: `${API_BASE_URL}/api/jobseeker/upload-cv`,
    VIEWCERTIFICATE: `${API_BASE_URL}/api/jobseeker/view-certificate`,
    VIEWCV: `${API_BASE_URL}/api/jobseeker/view-cv`,
    VIEWCOUNTIES: `${API_BASE_URL}/api/jobseeker/metadata/counties`,
    VIEWSKILLSPALETTE: `${API_BASE_URL}/api/jobseeker/metadata/skills-pool`,
    EMPJOBAPPS: `${API_BASE_URL}/api/jobseeker/my-applications`,
    SAVEDJOBS: `${API_BASE_URL}/api/jobseeker/saved-listings`,
    EMPLOYERSEARCH: `${API_BASE_URL}/api/jobseeker/employer-search`,
    EMPLOYERS: `${API_BASE_URL}/api/jobseeker/employers`,
};

export default API_BASE_URL;

